<template>
  <div
    v-if="!state.error"
    class="container"
    :class="$style.countryPage"
  >
    <button
      type="button"
      :class="$style.backButton"
      @click="backButtonHandler"
    >
      <ion-icon
        name="ios-arrow-round-back"
        size="large"
      /><span>Back</span>
    </button>
    <div v-if="!state.loading">
      <CountryDetailsContent
        :country="state.data[0]"
        @back="backButtonHandler"
      />
    </div>
    <div
      v-else
      :class="$style.countryPageLoading"
    >
      <Loader />
    </div>
  </div>
  <div
    v-else
    class="container"
  >
    Something went wrong
  </div>
</template>

<script>
import { reactive, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import useFetch from '@/composables/useFetch';

import CountryDetailsContent from '@/components/TheCountryDetailsContent.vue';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    CountryDetailsContent,
    Loader,
  },
  props: {
    countryName: {
      type: String,
      required: true,
    },
  },
  /* eslint-disable */
  setup() {
    const router = useRouter();
    const route = useRoute();
    const fetchData = useFetch();
    const state = reactive({
      loading: false,
      data: null,
      error: null,
    });
    async function loadCountry(countryName) {
      state.data = null;
      state.error = null;
      state.loading = true;
      const { fetchResult, fetchError } = await fetchData(`https://restcountries.eu/rest/v2/name/${countryName}?fullText=true`);
      if (fetchError.value) state.error = fetchError.value;
      else {
        state.data = fetchResult.value;
      }
      state.loading = false;
    }

    function backButtonHandler() { router.go(-1); }

    watch(route, (newVal) => {
      if(newVal.params.countryName) {
        loadCountry(newVal.params.countryName)
      }
    }, { immediate: true });

    return {
      state,
      backButtonHandler,
    };
  },
};
</script>

<style lang="sass" module>
@import '@/assets/scss/_shared'

.countryPage
  margin-top: 2.5rem

.backButton
  font-family: inherit
  font-weight: 600
  font-size: .874rem
  font-size: clamp(.875rem, 4vw, 1rem)
  background-color: $clr-elements
  background-color: var(--clr-elements)
  color: $clr-text
  color: var(--clr-text)
  padding: .3em 1em
  border: none
  box-shadow: $box-shadow-sm
  border-radius: $border-radius-xsm
  display: flex
  align-items: center
  justify-content: space-between
  gap: .2rem

  > ion-icon
    height: 3rem
    height: clamp(1.4rem, 4vw, 1.5rem)

.countryPageLoading
  display: flex
  align-items: center
  justify-content: center
  margin-top: 6rem
</style>
